export default __webpack_public_path__ + "static/media/csv_color.c915e4a1.svg";